<template>
  <div class="container_content">
    <!-- <nav-title>
      <div slot="title">{{$route.meta.title}}</div>
    </nav-title> -->
    <div class="content_nav-wrapper">
      <span
        v-for="(item, index) in menus"
        :key="index"
        @click="goUrl(item)"
        class="content_nav"
        :class="{ 'content_nav-active': $route.path == item.path }"
      >
        {{ item.name }}
      </span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    menus() {
      return this.$store.state.WindData.dataProcessMenu;
    }
  },
  methods: {
    goUrl(item) {
      let { path, name } = item;
      this.activeTxt = name;
      this.activeIndex = path;
      this.$router.push({ path });
    }
  }
};
</script>

<style></style>
